/** @jsx jsx */

import { Fragment as _, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import FiveStarRating from './FiveStarRating_v2';
import FiveStarList from './FiveStarList';
import Star from './Star';
import Message from './Message';
import SubmitBtn from './SubmitBtn';
import shouldUpdate from 'services/shouldUpdate';
import Image from 'components/lib/Image';
import { FeedbackSubmittedEditable } from './FeedbackSubmittedEditable';
import collectFeedbackSubmitted from 'assets/CC_AW_Feedback-min.png';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: ({ children, ...props }) => (
    <EditableText {...{ ...props, className: 'rating-text' }} />
  ),
  InteractionColumn: ({ children }) => {
    return children?.[0] || null;
  },
  Image: ({ children, ...props }) => {
    return (
      <Image
        {...{
          ...props,
          placeholder: collectFeedbackSubmitted,
        }}
      />
    );
  },
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  FiveStarRating,
  FiveStarList,
  FeedbackSubmitted: FeedbackSubmittedEditable,
  Star,
  TextArea: Message,
  ContinueButton: ContinueBtn,
  EditableButton: SubmitBtn,
  ...IELayout(interactionContext),
};

const FiveStarRatingDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default FiveStarRatingDisplay;
